<style>
#servitudeRegisterModal .v-select__selection {
  font-size: 12px;
}
</style>

<template>
  <div style="height: 85%">
    <ExportTableData
      ref="pobierz"
      :column-defs="columnDefs"
      :grid-options="gridOptions"
    ></ExportTableData>
    <v-layout>
      <v-flex xs7>
        <v-layout
          class="table--first-row"
          row
          wrap
        >
          <v-flex class="table__wrapper--center">
            <v-icon
              class="table__btn--green"
              @click="addServitude"
            >add_circle</v-icon>
            <p
              class="caption"
              @click="addServitude"
            >DODAJ SŁUŻEBNOŚĆ</p>
            <v-icon
              class="table__btn--blue table__btn--padding"
              v-show="selectedRow"
              @click="openServitudeCard"
            >note</v-icon>
            <p
              class="caption"
              v-show="selectedRow"
              @click="openServitudeCard"
            >OTWÓRZ KARTĘ</p>
            <v-icon
              class="table__btn--red table__btn--padding"
              v-show="selectedRow"
              @click="removeRow"
            >delete</v-icon>
            <p
              class="caption"
              v-show="selectedRow"
              @click="removeRow"
            >USUŃ</p>
          </v-flex>
          <v-spacer />
        </v-layout>
        <v-layout
          row
          wrap
        >
          <v-flex class="table__wrapper--center">
            <v-icon
              @click="'pobierz' in $refs && $refs.pobierz.showExportMenu($event)"
              class="table__btn--blue"
            >cloud_download</v-icon>
            <p
              class="caption"
              @click="'pobierz' in $refs && $refs.pobierz.showExportMenu($event)"
            >POBIERZ REJESTR</p>
            <v-icon
              class="table__btn--padding"
              v-show="selectedRow"
              @click="zoomToBBox"
              style="margin-left: 15px;"
            >zoom_in</v-icon>
            <p
              class="caption"
              v-show="selectedRow"
              @click="zoomToBBox"
            >PRZYBLIŻ</p>
          </v-flex>
          <v-spacer />
        </v-layout>
      </v-flex>
      <v-flex
        xs5
        class="table__wrapper--center table__wrapper--filter"
      >
        <v-layout
          align-right
          justify-end
        >
          <v-select
            :items="servitudeStatuses"
            label="Filtr: status"
            v-model="filterStatus"
            hide-details
            clearable
            @change="filterByStatus(filterStatus)"
            style="padding-right:10px;"
          ></v-select>
          <v-text-field
            type="text"
            v-model="filter"
            placeholder="Treść filtra"
            clearable
            :hint="numberFiltered + '/' + numberAll"
            persistent-hint
            filled
          >
          </v-text-field>
        </v-layout>
      </v-flex>
    </v-layout>
    <ag-grid-vue
      class="ag-theme-balham"
      :gridOptions="gridOptions"
      style="height: 90%"
    ></ag-grid-vue>
  </div>
</template>

<script>
import {AgGridVue} from "ag-grid-vue";
import ExportTableData from "../../shared/ExportTableData";

export default {
  name: "App",
  data: () => ({
    tableTitle: "servitudesTable",
    filter: "",
    inspectionsTaskFiltered: undefined,
    numberAll: '0',
    numberFiltered: '0',
    servitudeStatuses: [],
    filterStatus: "",
    selectedRow: undefined
  }),
  components: {
    AgGridVue,
    ExportTableData,
  },
  watch: {
    filter(nV) {
      this.gridOptions.api.setQuickFilter(nV);
      this.numberFiltered = this.gridOptions.api.getModel().rootNode.childrenAfterFilter.length;
    }
  },
  computed: {
    gridOptions() {
      let gridOptions = {
        rowData: this.loadData(),
        overlayLoadingTemplate:
          '<span class="ag-overlay-loading-center">Trwa ładowanie danych</span>',
        columnDefs: this.columnDefs,
        enableSorting: "true",
        enableFilter: "true",
        enableColResize: "true",
        onGridReady: this.onGridReady,
        onFilterModified: this.filteredNumber,
        onFilterChanged: this.filterColumn,
        onColumnMoved: this.onColumnMoved,
        onColumnResized: this.onColumnMoved,
        rowSelection: "single",
        onSelectionChanged: this.onSelectionChanged,
        localeText: {
          contains: "Zawiera",
          notContains: "Nie zawiera",
          equals: "Równa się",
          notEqual: "Nie równa się",
          startsWith: "Zaczyna się",
          endsWith: "Kończy się",
          noRowsToShow: "Brak danych"
        }
      };
      return gridOptions;
    },
    activeModals() {
      return this.$store.getters.getModalsList;
    },
    servitudes() {
      return this.$store.getters.getServitudes;
    }
  },
  beforeMount() {
    this.columnDefs = [
      {
        headerName: "ID",
        field: "id",
        sort: "asc"
      },
      {headerName: "Adres", field: "address"},
      {headerName: "Kontakt", field: "contact"},
      {
        headerName: "Data",
        field: "date",
        valueGetter: value => {
          return new Date(value.data.date).toLocaleString("pl-PL", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
          });
        }
      },
      {headerName: "Właściciel", field: "owner"},
      {headerName: "Typ właściciela", field: "owner_type"},
      {headerName: "Numer działki", field: "parcel"},
      {headerName: "Obręb", field: "precinct_name"},
      {headerName: "Numer księgi wieczystej", field: "register_number"},
      {headerName: "Numer repertorium", field: "repertory_number"},
      {headerName: "Szerokość pasa gruntu obciążonego służebnością przesyłu", field: "width"},
      {
        headerName: "Status",
        field: "status",
        filter: "agTextColumnFilter"
      }
    ];
  },
  methods: {
    filterColumn() {
      this.numberFiltered = this.gridOptions.api.getModel().rootNode.childrenAfterFilter.length.toString();
    },
    addServitude() {
      this.$modal.hide('servitudeRegisterModal');
      this.$store.commit("setServitudeAdding", true);
      this.$root.$emit('toggleLayer', 'app_layer_Zlotoryja:granice_dzialek', true);
      this.$root.$emit(
        "showSnackbar",
        "info",
        "Wybierz działkę poprzez kliknięcie w jej granicę na mapie"
      );
      this.$root.$emit("identificationFeature", 'start');
    },
    openServitudeCard() {
      let payload = {
        object_id: this.selectedRow.id,
        object_table: null,
        object_type: "transmission_easement",
        limit: 5,
        events_count: true
      };

      this.$store.dispatch("getServitude", {
        object_id: this.selectedRow.id,
        with_geometry: 'true'
      }).then(r => {
        if(r) {
          this.$store
            .dispatch("getFeatureEvents", payload)
            .then(success => {
              if(success) {
                this.show('servitudeCardModal');
              } else {
                this.$root.$emit(
                  "showSnackbar",
                  "red",
                  "Podczas pobierania służebności przesyłu wystąpił błąd"
                );
              }
            });

        }
      });
    },
    getServitudeStatuses() {
      let payloadStatuses = {
        schema: "registry",
        table: "transmission_easement",
        column: "status"
      };
      this.$store.dispatch('getDictSTC', payloadStatuses).then(r => {
        this.servitudeStatuses = r.values;
      });
    },
    loadData() {
      this.$store.dispatch("getServitudes", {
        with_bbox: 'true'
      }).then(r => {
        if(r) {
          this.numberAll = r.transmission_easement.length;
          this.numberFiltered = this.numberAll;
          this.gridOptions.api.setRowData(r.transmission_easement);
        }
      });
    },
    show(title) {
      if(this.activeModals.indexOf(title) == -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    },
    onColumnMoved(params) {
      const columnState = JSON.stringify(
        this.gridOptions.columnApi.getColumnState()
      );
      localStorage[this.tableTitle] = columnState;
    },
    onGridReady(params) {
      if(localStorage[this.tableTitle]) {
        const columnState = JSON.parse(localStorage[this.tableTitle]);
        if(columnState) {
          this.gridOptions.columnApi.setColumnState(columnState);
        }
      }
      this.getServitudeStatuses();
    },
    onSelectionChanged() {
      this.selectedRow = this.gridOptions.api.getSelectedRows()[0];
    },
    filteredNumber() {
      this.numberFiltered = this.gridOptions.api.getModel().getRowCount();
    },
    removeFilters() {
      this.gridOptions.api.setFilterModel(null);
      this.filteredNumber();
      this.filter = "";
      this.filterStatus = "";
    },
    filterByStatus(value) {
      let statusFilter = this.gridOptions.api.getFilterInstance(
        "status"
      );
      statusFilter.setModel({
        type: "equals",
        filter: value
      });
      this.gridOptions.api.onFilterChanged();
      this.filteredNumber();
    },
    removeRow() {
      let oid = this.selectedRow.id;
      this.$emit("confDialogOpened", true);
      this.$modal.show("dialog", {
        title: "Usuwanie służebności",
        text: "Czy na pewno chcesz usunąć służebność?",
        buttons: [
          {
            title: "NIE",
            handler: () => {
              this.$emit("confDialogOpened", false);
              this.$modal.hide("dialog");
              return;
            }
          },
          {
            title: "TAK",
            default: true,
            handler: () => {
              this.$store
                .dispatch("removeServitude", oid)
                .then(success => {
                  if(success) {
                    this.loadData();
                  } else {
                    this.$root.$emit(
                      "showSnackbar",
                      "red",
                      "Podczas usuwania inspekcji wideo wystąpił błąd"
                    );
                  }
                });
              this.$emit("confDialogOpened", false);
              this.$modal.hide("dialog");
            }
          }
        ]
      });
    },
    zoomToBBox() {
      this.$root.$emit('zoomToBBox', this.selectedRow.bbox);
    }
  },
  mounted() {
    this.$on("filterByStatus", this.filterByStatus);
    this.$on("removeFilters", this.removeFilters);
    this.$root.$on("edited_servitude", this.loadData);

  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/table/ServitudesTable.vue